export default __webpack_public_path__ + "static/media/badge-tmobile.39732f44.png";